module.exports = __webpack_public_path__ + "img/adv2.png";